module.exports = __webpack_public_path__ + "static/img/kols17.c50ab3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/kols/kols17.png
// module id = apRa
// module chunks = 0